class CstmCollection extends HTMLElement {
  constructor() {
    super();
    this.isAdditionalCollection = this.querySelector(
      "[data-additional-collection]"
    )
      ? true
      : false;
    this.collectionUrl = this.querySelector(
      "[data-collection-url]"
    )?.dataset.collectionUrl;
  }
  connectedCallback() {
    if (this.isAdditionalCollection) {
      this.renderAdditionalFilters();
    }
  }
  async renderAdditionalFilters() {
    await fetch(this.collectionUrl)
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, "text/html");
        const newCollectionUrl = html.querySelectorAll("[data-collection-url]");
        if (newCollectionUrl) {
          newCollectionUrl.forEach((url) => {
            if (url.dataset.collectionUrl == this.collectionUrl) {
              const newFilters = html.querySelector(".cat-s2-header");
              if (newFilters) {
                this.querySelector(".cat-s2-header").innerHTML =
                  newFilters.innerHTML;
              }
            }
          });
        }
      })
      .finally(() => {
        this.querySelector("cstm-filters")?.connectedCallback();
      });
  }
}

customElements.define("cstm-collection", CstmCollection);

class CstmFilters extends HTMLElement {
  constructor() {
    super();
    this.ContentBlock = this.closest(".content-block");
    this.ProductList = this.ContentBlock?.querySelector(".catalog-2col-grid");
    this.sectionId = this.closest("[data-id]")?.dataset.id;
    this.abortController = null;
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.isFixed = this.classList.contains('fixed');
  }

  connectedCallback() {
    this.updateListeners();

    const slidesCount = this.querySelectorAll('.splide__slide').length;
    const splide = new Splide(this.querySelector(".filters-splide"), {
      type: 'slide',
      speed: 200,
      gap: '8rem',
      padding: 0,
      autoHeight: true,
      width: true,
      arrows: false,
      pagination: false,
      rewind: false,
      perMove: 1,
      perPage: 'auto',
      focus: 0,
      flickMaxPages: 1,
      snap: true,
      trimSpaces: false,
      waitForTransition: false,
      releaseWheel: true,
      breakpoints: {
      }
    });

    splide.on('overflow', function(isOverflow) {
      splide.go(0);
      splide.options = {
        drag: isOverflow,
        clones: isOverflow ? undefined : 0
      };
    });

    splide.on('moved', function() {
      // Re-enable clicks immediately after move
      splide.root.style.pointerEvents = 'auto';
    });

    splide.mount();
    this.MainSlider = splide;
    
    if (this.isFixed === true) {
      this.filters[0]?.click();
    };
  }

  disconnectedCallback() {
    this.removeListeners();
    this.abortFetch();
  }

  abortFetch() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  handleFilterClick(event) {
    event.preventDefault();
    const catFilter = event.currentTarget;
    const value = catFilter.dataset.value;
    
    if (this.isFixed === true) {
      const activeFilter = this.filters.find((f) => f.classList.contains('is-active'));
      activeFilter?.classList.toggle('is-active');
    };
    catFilter.classList.toggle('is-active');

    const activeFilters = this.filters.filter((f) => f.classList.contains('is-active'));

    const activeVariantIds = activeFilters.map((f) => {
      const idDivs = Array.from(f.querySelectorAll('#variant-ids > div'));
      return idDivs.map(div => div.dataset.variantId);
    }).flat();
    
    let activeIds = [];
    let idAttribute = "";
    if (activeVariantIds.length > 0) {
      activeIds = activeVariantIds;
      idAttribute = 'variantId';
    } else {
      activeIds = activeFilters.map((f) => {
      const idDivs = Array.from(f.querySelectorAll('#product-ids > div'));
        return idDivs.map(div => div.dataset.productId);
      }).flat();
      idAttribute = 'productId';
    };
    
    const productCards = Array.from(this.ProductList.querySelectorAll('product-card'));

    if (activeIds.length === 0) {
      productCards.forEach((card) => card.classList.remove('hidden'));
      return;
    };

    productCards.forEach((card) => {
      if (activeIds.includes(card.dataset[idAttribute]) === true) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      };
    });
  }

  updateListeners() {
    this.collectionUrl = this.closest(
      "[data-collection-url]"
    )?.dataset.collectionUrl;
    this.isAdditionalCollection = this.closest("[data-additional-collection]")
      ?.dataset.additionalCollection
      ? true
      : false;
    this.filters = Array.from(this.querySelectorAll(".cat-filter-button"));
    this.filters.forEach((filter) => {
      filter.addEventListener("click", this.handleFilterClick);
    });
  }

  removeListeners() {
    if (this.filters) {
      this.filters.forEach((filter) => {
        filter.removeEventListener("click", this.handleFilterClick);
      });
    }
  }
}

customElements.define("cstm-filters", CstmFilters);

class CstmPagination extends HTMLElement {
  constructor() {
    super();
    this.handlePaginationClick = this.handlePaginationClick.bind(this);
  }

  connectedCallback() {
    this.updateListeners();
    this.isAdditionalCollection = this.closest("[data-additional-collection]")
      ? true
      : false;
    
    const parentSection = this.closest("[data-pagination-id]");
    const hasLoaded = parentSection?.hasAttribute("data-first-load-done");
    
    if (this.isAdditionalCollection && !hasLoaded) {
      parentSection?.setAttribute("data-first-load-done", "true");
      this.handlePaginationClick(null, true);
    }
  }

  handlePaginationClick(event, isAuto = false) {
    let req;
    if (event) {
      event.preventDefault();
      req = event.currentTarget.href.split("?")[1];
    } else if (isAuto) {
      req = "page=1";
    } else {
      return;
    }

    const url = this.collectionUrl + "?" + req;
    
    try {
      fetch(url)
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const newProductList = html.querySelector(
            `[data-pagination-id="${this.sectionId}"]`
          );          
          if (newProductList) {
            const productList = this.closest(
              `[data-pagination-id="${this.sectionId}"]`
            );
            
            if (productList && newProductList) {
              const firstLoadDone = productList.hasAttribute("data-first-load-done");
              productList.innerHTML = newProductList.innerHTML;

              if (firstLoadDone) {
                productList.setAttribute("data-first-load-done", "true");
              }

              const newPagination = productList.querySelector("cstm-pagination");
              if (newPagination) {
                newPagination.updateListeners();
              }
            }
          }
        })
        .catch((error) => {
          console.error("Failed to fetch pagination:", error);
        });
    } catch (error) {
      console.error("Failed to fetch pagination:", error);
    }
  }

  updateListeners() {
    this.collectionUrl = this.closest(
      "[data-pagination-collection]"
    )?.dataset.paginationCollection;
    
    this.sectionId = this.closest("[data-pagination-id]")?.dataset.paginationId;
    
    if (this.paginationLinks) {
      this.paginationLinks.forEach((link) => {
        link.removeEventListener("click", this.handlePaginationClick);
      });
    }
    
    this.paginationLinks = this.querySelectorAll("a");
    
    this.paginationLinks.forEach((link) => {
      link.addEventListener("click", this.handlePaginationClick);
    });
  }

  disconnectedCallback() {
    if (this.paginationLinks) {
      this.paginationLinks.forEach((link) => {
        link.removeEventListener("click", this.handlePaginationClick);
      });
    }
  }
}

customElements.define("cstm-pagination", CstmPagination);
